const typographyCompleteActionModal = {
  post: 'Escreva seu comentário:',
  file: 'Anexar Arquivos'
};

export default typographyCompleteActionModal;
